export default "__VITE_ASSET__77e6dcf9__"